//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'button-toggle',

  data () {
    return {
      inputValue: this.value
    }
  },

  props: {
    options: {
      type: Array,
      default: () => []
    },

    multiple: Boolean,

    value: {
      required: false
    }
  },

  computed: {
    classes () {
      return {
        'btn-toggle--selected': this.inputValue && !this.multiple || this.inputValue && this.inputValue.length > 0
      }
    }
  },

  watch: {
    value () {
      this.inputValue = this.value
    }
  },

  methods: {
    isSelected (item) {
      if (!this.multiple) {
        return this.inputValue === item.value
      }

      return this.inputValue.includes(item.value)
    },

    updateValue (item) {
      if (!this.multiple) {
        return this.$emit('input', this.inputValue === item.value ? null : item.value)
      }

      const items = this.inputValue

      const i = items.indexOf(item.value)
      if (i !== -1) {
        items.splice(i, 1)
      } else {
        items.push(item.value)
      }

      this.$emit('input', items)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/ButtonToggle.vue